import script from "./PhotoUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoUpload.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoUpload.vue?vue&type=style&index=0&id=0a4f0d36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4f0d36"]])

export default __exports__